@if (isFirst) {
  <td>
    <material-order-position-status [id]="position.position_id"
      [status]="position.status"
      (updatePosition)="updatePositionEmitter.emit($event)">
    </material-order-position-status>
  </td>
  <td class="align-right">{{position.index + 1}}</td>
  <td class="align-right">
    @if (position.delivery_index === 0) {
      <span>1</span>
    }
    @if (position.delivery_index > 0) {
      <strong>{{position.delivery_index + 1}}</strong>
    }
  </td>
  @if (groupPermission) {
    <td>
      <a uiSref="a.material.inventory.update" target="_blank" [uiParams]="{variation: position.id}">
        {{position.variation_id}}
      </a>
    </td>
  }
  @if (!groupPermission) {
    <td>
      {{position.variation_id}}
    </td>
  }
  <td>{{position.vendor_article_id}}</td>
  <td>{{position.article_name}}</td>
  @for (field of fields; track field) {
    <td [ngClass]="{'align-right': field.isValueType('Number')}">
      @if (!(position.fields[field.html_name]|isNull)) {
        @switch (field.data_type) {
          @case ('Option') {
        <i class="fa" [ngClass]="{
          'fa-check': (position.fields[field.html_name] === true),
          'fa-times': (position.fields[field.html_name] === false)}"></i>
          }
          @case ('Ganzzahl') {
            {{ position.fields[field.html_name] | money:0 }}
          }
          @case ('Kommazahl') {
            {{ position.fields[field.html_name] | money }}
          }
          @default {
            {{ position.fields[field.html_name] }}
          }
        }
      }
    </td>
  }
  <td>{{position.date_delivery|date:'dd.MM.yyyy'}}</td>
  <td class="align-right">{{ position.amount_ordered|money }}</td>
}

@if (!isFirst) {
  <td [colSpan]="8 + fields.length"></td>
}

@if (('material.order.price.check'|HasPerm)) {
  @if (transaction.new_transaction === true) {
    <td class="align-right" [formGroup]="formTransaction">
      <input type="text"
        class="form-control inline-block align-right"
        style="width: 65px;"
        formControlName="price"
        [ngClass]="{'red_alert': !!errorPrice}"/>
    </td>
  }
  @if (transaction.new_transaction !== true) {
    <td class="align-right">
      @if (!!position.price) {
        {{position.price|money:2}}&nbsp;&euro;
      }
    </td>
  }
  @if (!isFirst) {
    <td class="align-right"></td>
  }
  @if (isFirst) {
    <td>
      <a class="inline-block click" [title]="setStatusTooltip" (click)="confirmPrice()">
        <i class="fa row-icon" [ngClass]="positionPriceConfirmed" aria-hidden="true"></i>
      </a>
    </td>
  }
}

<td>{{transaction.transaction.charge}}</td>
<td>{{transaction.transaction.location}}</td>
<td class="align-right">{{ transaction.transaction.amount|money }}</td>

<td class="icon">
  <a [href]="pdfUri"
    target="_blank"
    title="Etiketten PDF öffnen">
    <i class="fa fa-file-pdf-o row-icon" aria-hidden="true"></i>
  </a>
</td>

<td class="icon">
  <a class="click"
    title="Zusammen eingebuchtes Material anzeigen"
    (click)="openPrint(transaction.id)">
    <i class="fa fa-info-circle row-icon" aria-hidden="true"></i>
  </a>
</td>

<td>
  @if (('material.order.status'|HasPerm)) {
    <a class="click"
      title="Positionsstatus auf &quot;Bestätigt&quot; zurücksetzen"
      (click)="setStatus(1)"
      >
      <i class="fa fa-undo row-icon" aria-hidden="true"></i>
    </a>
  }
</td>

<td class="icon">
  <a class="click"
    title="Einbuchung und alle dazugehörigen Umbuchungen löschen"
    (click)="remove()">
    <i class="fa fa-trash-o red_font row-icon" aria-hidden="true"></i>
  </a>
</td>

@if (('material.order.price.check'|HasPerm)) {
  <td class="icon">
    <a [href]="finderSupplierUri"
      target="_blank"
      class="click"
      title="Im envisia finder öffnen">
      <img src="/ui/assets/images/logo_e_icon.svg" width="20px">
    </a>
  </td>
}

<td class="icon">
  <material-label-print-button [variationId]="position.id" classInner="fa-2x"></material-label-print-button>
</td>
